import type { ReactNode } from 'react';
import { cssColor } from '../colors';
import { initials } from '../format';

export interface UserBadgeProps {
  name: string;
  color?: string | null;
  size?: 'small' | 'normal';
  /** Rolle als Zusatztext hinter dem Namen. */
  roleName?: string | null;
}

/** Name mit farbigem Rollen-Punkt (Avatar). */
export function UserBadge({ name, color, size = 'normal', roleName }: UserBadgeProps): ReactNode {
  const css = cssColor(color);
  return (
    <span className={size === 'small' ? 'user-badge user-badge-small' : 'user-badge'}>
      <span className="user-dot" style={{ backgroundColor: css }} aria-hidden="true">
        {initials(name)}
      </span>
      <span className="user-badge-name">{name}</span>
      {roleName !== undefined && roleName !== null && roleName !== '' && (
        <span className="user-role-pill" style={{ borderColor: css, color: css }}>
          {roleName}
        </span>
      )}
    </span>
  );
}

/** Nur der farbige Punkt (z. B. in dichten Listen). */
export function ColorDot({ color, title }: { color?: string | null; title?: string }): ReactNode {
  return <span className="color-dot" style={{ backgroundColor: cssColor(color) }} title={title} />;
}
